import React from 'react';
import { Card, CardContent } from './ui/Card';
import { BoxIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string | number;
  icon: BoxIcon;
  trend?: string;
  trendUp?: boolean;
}
export function StatCard({
  title,
  value,
  icon: Icon,
  trend,
  trendUp
}: StatCardProps) {
  return <Card className="border-gray-200 hover:shadow-md transition-shadow" data-id="element-587">
      <CardContent className="p-6" data-id="element-588">
        <div className="flex items-start justify-between" data-id="element-589">
          <div className="flex-1" data-id="element-590">
            <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-591">{title}</p>
            <p className="text-3xl font-bold text-gray-900" data-id="element-592">{value}</p>
            {trend && <p className={`text-sm mt-2 font-medium ${trendUp ? 'text-green-600' : 'text-gray-500'}`} data-id="element-593">
                {trend}
              </p>}
          </div>
          <div className="h-12 w-12 rounded-lg bg-[#139191]/10 flex items-center justify-center" data-id="element-594">
            <Icon className="h-6 w-6 text-[#139191]" data-id="element-595" />
          </div>
        </div>
      </CardContent>
    </Card>;
}